class Cycle{
    constructor(points=[]){
        this._points = points;
        this.material = window.materials.floor[0].clone();
    }

    get length(){
        return this._points.length;
    }

    set points(points){
        this._points = points;
    }

    get points(){
        return this._points;
    }
}
export default Cycle;
